<p-table
    class="cases-table"
    size="small"
    [columns]="columns"
    [value]="paginatedList?.pageItems"
    [paginator]="true"
    [lazy]="true"
    [first]="first"
    [(rows)]="numberOfItemsPerPage"
    [rowsPerPageOptions]="[5,10,15,20]"
    [totalRecords]="paginatedList?.totalCount"
    (onLazyLoad)="onPageChange($event)"
    selectionMode="single"
    [loading]="isLoading"
    [alwaysShowPaginator]="paginatedList?.totalCount > 0"
    [scrollable]="true"
  >
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns">
        {{ 'Reports.Columns.' + col.name | translate }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-case let-columns="columns">
     <tr (click)="onSelected(case)">
      <td *ngFor="let col of columns" [ngClass]="{'text-center': col.type == 'boolean'}">
        <ng-container [ngSwitch]="col.type">

          <ng-container *ngSwitchCase="'date'">
            {{ case[col.name.decapitalize()] | date: localizationSettings.datePipeFormat }}
          </ng-container>

          <ng-container *ngSwitchCase="'decimal'">
            {{ case[col.name.decapitalize()] | number : localizationSettings.numberPipeFormat.style: localizationSettings.numberPipeFormat.culture }}
          </ng-container>

          <ng-container *ngSwitchCase="'maybedate'">
            <ng-container *ngIf="getStringList(case[col.name.decapitalize()]) as stringList; else noList">
              <ng-container *ngFor="let stringItem of stringList; let last = last">
                <ng-container *ngIf="tryGetDate(stringItem) as itemDate; else noDate">
                  {{ itemDate | date: localizationSettings.datePipeFormat }}
                </ng-container>
                <ng-template #noDate>{{ stringItem }}</ng-template>
                <span *ngIf="!last">, </span>
              </ng-container>
            </ng-container>
            <ng-template #noList>
              {{ case[col.name.decapitalize()] }}
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchCase="'color'">
              <div [class]="col.name.decapitalize()" [style.backgroundColor]="case[col.name.decapitalize()]"></div>
          </ng-container>

          <ng-container *ngSwitchDefault>{{case[col.name.decapitalize()]}}</ng-container>
        </ng-container>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="paginatorleft">
    <label class="label" (click)="onExportExcelClick.emit('exportExcel')">
      {{ 'General.Download' | translate }}
    </label>
  </ng-template>
</p-table>
